import { CodeAspect } from './code.aspect';

export type { CodeUI, FileIconSlot } from './code.ui.runtime';
export { CodeAspect };
export default CodeAspect;
